(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * This plugin detects video loading.
     *
     * Sends 'loading_changed' message with true as 2nd argument if started loading and false if resumed playback.
     *
     * @namespace loading
     */

    /**
     * @module Messages
     *
     * Generated by the loading plugin based on state_changed timing changes.
     *
     * @function loading_changed
     * @param {String}  messageKind='loading_changed'
     * @param {Boolean} isLoading
     */


    var plugin = function(vc, ui, pub) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;

        this._vc.subscribe('canplay error load playing waiting', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'loading2',

        on: function(mt) {
            //console.log(mt);
            switch (mt) {
                case 'playing':
                case 'error':
                    this._pub('loading_changed', false); // NOT LOADING
                    break;

                case 'load':
                case 'waiting':
                    this._pub('loading_changed', true); // LOADING
                    break;
            }
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
